function Container() {
    /// <summary>
    /// This object provides common functions for the Widget.Container visuals. <br/>
    /// Author: ARF<br />
    /// Date: 10.9.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 18.1.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.sDate = null;
}
Container.prototype = new vcTemplate();

Container.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
  var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);


         me.visual.find("#div-signal-selection").vcOptionBox({
             caption: me.resources.selection,
             items: [
                 {
                     button: me.resources.signals, content: me.visual.find('#div-ddl-signal').html(), isList: true,
                     funct: function () {
                         me.visual.find('#div-signal-selection #ddlSignal').chosen({ no_results_text: me.resources.noEntriesExist });
                         me.visual.find('#div-signal-selection #ddlSignal').off('change').on('change', function () { return me.load(); });
                     }
                 }
             ]
        });
        me.visual.find("#div-signal-selection").removeClass("vc-grid-2col").addClass("vc-grid-3col");

        me.visual.find(".vc-cal").vcDateBox(
            {
                mode: me.navigationModus, interval: me.navigationStep, langID: me.userLangidForCulture,
            callback: function (obj) {
                if (obj.mode === "Single") {
                    me.sDate = obj.singleDate;
                } else {
                    me.sDate = obj.dateRange.from;
                }
                _VCMQ.produce(me.visual, me.vcgid, 'COCKPIT_SETDATE', me.sDate);
                me.load();
            } }
        );


        //we init the hidden share url icon
        if (me.signalParameter.ShowShareUrl) {
            me.visual.find("#i-share-url").vcShareUrlIcon({ invokeType: "addVisualBase", vcgid: "-1" });

            me.visual.on("click", ".div-open-share-url", function (e) {
                var obj = $(e.target);
              
                var urlInfo = {
                    'info': { bsaid: obj.data("bsaid"), name: '', description: '', startDate: me.sDate, endDate: me.sDate, dateUserDef: false, interval: 1 },
                    'visualname': obj.data("visualname"),
                    'parameter': obj.data("parameter"),
                    'signalparameter': obj.data("signalparameter")
                }
             
                window._VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS', urlInfo);
                me.visual.find("#i-share-url").vcShareUrlIcon("show");
                //alert("go");
            });



        }

        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


Container.prototype.load = function () {
    /// <summary>
    /// This function loads the content.
    /// </summary>
    var me = this;
    var bsaid;
   
    try {
        if (me.error) { return false; }
        //TODO AFU - selector changed by MWI from ' #ddlSignal' to '#div-signal-selection #ddlSignal'
        if (me.visual.find('#div-signal-selection #ddlSignal').length > 0) {
            bsaid = parseInt(me.visual.find('#div-signal-selection #ddlSignal').val(),10);
        } else {
            bsaid = -1;
        }
        if (isNaN(bsaid)) {bsaid = -1}
        me.signalParameter.bsaid = bsaid;

        if (me.sDate === null) {return false}
       // sDate = me.visual.find(".vc-cal").vcDate("getDate");
        //sDate = me.visual.find(".txtDate").val();
        me.visual.find('#divContent').html(me.vcC.getLoadingIcon());

        window.VisualCoreService.getData(me.vcvid, me.vcgid, me.sDate, me.height, me.width, '', JSON.stringify(me.signalParameter), me.deviceType, me.langid, JSON.stringify(JSON.stringify(me.signalParameter)),
            function(result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData,true);
                    return false;
                }
                if (result === '') {
                    me.showMessage(me.resources.err_loadData,true);
                    return false;
                }
                me.visual.find('#divContent').html(result);





                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('load', ex);
        return false;
    }
};

Container.prototype.doEvent = function() {}




